module.exports = "/images/blueBlockIcon.svg?340eb3fc93ee80979d1a483569e5f411";